<template>
  <v-card>
    <v-form ref="form" disabled>
      <v-card-text class="px-4 py-4 mb-2">
        <v-row>
          <v-col cols="6">
            <h1 class="d-inline me-5" v-if="formData">
              <template v-if="formData.market && formData.market.setting && formData.market.setting.receiptTopic">
                {{ formData.market.setting.receiptTopic }}
              </template>
              <template v-else-if="formData.totalVatValue > 0">
                {{ $t('invoice.receipt_and_tax_bill_space') }}
              </template>
              <template v-else>
                {{ $t('receipt.title') }}
              </template>
            </h1>
            <br />
            <h2 class="d-inline me-5" v-if="formData && formData.documentId">
              {{ formData.documentId }}
            </h2>
          </v-col>
          <v-col cols="6" class="mt-2 text-right" v-if="formData">
            <v-btn color="default" elevation="2" outlined class="mx-2 my-1" @click="dismiss()"
              :disabled="isSaving">{{ $t('close_window') }}</v-btn>
            <template v-if="!isLoading">

              <div v-if="formData.isPaid" class="grouping-print-btn">
                <v-btn color="info" elevation="2" @click="printClick('th')" :disabled="isSaving || isLoading">
                  <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('bill.print_receipt') }}
                </v-btn>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card elevation="3" class="pt-5 mx-5 ps-5" v-if="!isLoading">
        <div class="card-receipt-form">
          <div class="mb-10 pe-5">
            <v-row>
              <v-col cols="12" sm="12" md="5" lg="3">
                <span>
                  <b>{{ $t('customer.company_name_and_customer_name') }}</b>
                </span>
                <v-text-field v-model="formData.customerData.name" :rules="[rules.required]"
                  :placeholder="$t('customer.company_name_and_customer_name')" class="mb-4 input-disable" outlined dense
                  hide-details></v-text-field>
                <p class="mb-3">
                  <b>{{ $t('detail') }}</b>
                </p>
                <v-textarea v-model="formData.customerData.address" :placeholder="$t('address.address_detail')"
                  :label="$t('address.address_detail')" class="mb-2" outlined dense hide-details rows="2" no-resize></v-textarea>

                <v-row no-gutters>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.branchName"
                      :class="`mb-1 ${formData.customerData.taxId ? 'mt-9' : 'mt-9'}`" :placeholder="$t('address.company_branch')"
                      :label="$t('address.company_branch')" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <EditTaxId v-model='formData.customerData.taxId'
                      :customClassLabel="'d-block mb-3'" :customClassWarning="'mb-2'" showWarning
                      :showLabel='false' :getIsVat="customerType == 'company' ? true : false" :getIsExport='false'
                      showPlaceholder :customClassInput="'mb-2'" :solo='false' :flat='false' outlined
                      dense :counter='false' hideDetails />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.tel" class="mb-2" :placeholder="$t('account.phone_number')"
                      :label="$t('account.phone_number')" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <v-text-field v-model="formData.customerData.email" class="mb-2" placeholder="Email" label="Email"
                      outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="orange" elevation="2" class=" my-1 white--text" @click="isBillHederDialog = true"
                      :disabled="isSaving || isLoading">
                      <v-icon dark class="me-2">mdi-clipboard-edit-outline</v-icon>{{ $t('customer.edit_customer_data') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col></v-col>

              <v-col cols="12" sm="12" md="5" lg="3">
                <div class="mb-3">
                  <h1 v-if="formData.isPaid" class="green--text">{{ $t('payment.paid') }}</h1>
                  <h1 v-if="!formData.isPaid" class="red--text">{{ $t('payment.cancel_payment') }}</h1>
                  <template v-if="formData.qrPaymentReport">
                    <small v-if="formData.qrPaymentReport.isVoided">{{ $t('payment.refund_payment_success') }}
                      <span v-if="formData.qrPaymentReport.voidedDate">{{ $t('when') }} {{
                        $moment(formData.qrPaymentReport.voidedDate.iso).format('DD MMM YYYY, HH:mm ' + $t('timeunit.minute.short')) }}</span>
                    </small>
                    <small v-else-if="!formData.isPaid">
                      {{ $t('payment.refund_payment_failed') }}
                      <span v-if="formData.qrPaymentReport.voidedResult.errorDesc_th"> {{
                        formData.qrPaymentReport.voidedResult.errorDesc_th }}</span>
                      <span v-else-if="formData.qrPaymentReport.voidedResult.errorDesc"> {{
                        formData.qrPaymentReport.voidedResult.errorDesc }}</span>
                    </small>
                  </template>
                </div>
                <p class="mb-0">
                  <b>{{ $t('payment.total_amount_all_payment') }}</b>
                </p>
                <h1 class="mb-7">
                  {{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}
                  <h4 class="d-inline red--text" v-if="formData.totalUnpaidValue">{{ $t('payment.remaining') }} {{ formData.totalUnpaidValue | currencySuffixTextThEn(formData.currencyCode) }}</h4>
                </h1>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('date') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(formData.date)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formData.date" no-title locale="th" @input="menuDate = false"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('project.employee') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <v-text-field :placeholder="$t('project.employee')" outlined dense hide-details :value="userFullName" readonly
                      disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('payment.currency') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <CurrencySelect 
                      v-model="formData.currencyCode" 
                      disabled
                    />
                  </v-col>
                </v-row>
                <v-row v-if="formData.invoice">
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('invoice.reference_invoice') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">
                    <a href="#" @click="clickInvoice(formData.invoice)">{{ formData.invoice.documentId }}</a>
                  </v-col>
                </v-row>
                <v-row v-if="formData.order">
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('payment.reference_order') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">
                    <a href="#" @click="dialogMeterOrderDetail = true">{{ formData.order.documentId }}</a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr class="my-5" />
            <v-row class="mb-0">
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('product.product_price') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-select v-model="formData.isVatInclusive" :placeholder="$t('product.product_price')" :items="[
                      {
                        text: $t('payment.price_vat_exclusive'),
                        value: false,
                      },
                      {
                        text: $t('payment.price_vat_inclusive'),
                        value: true,
                      },
                    ]" item-text="text" item-value="value" @change="onChangeIsVatInclusive()" outlined dense
                      hide-details :no-data-text="$t('noinfo')"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div style="border-radius: 10px; overflow: hidden">
              <v-simple-table v-if="formData.items && formData.items.length">
                <template v-slot:default>
                  <thead class="table-item header rounded-2">
                    <tr>
                      <th width="5%" class="text-center">{{ $t('rank') }}</th>
                      <th>{{ $t('product.product_name_and_detail') }}</th>
                      <th width="8%">{{ $t('area.space') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.quantity') }}</th>
                      <th width="8%">{{ $t('unit') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                      <th width="8%">{{ $t('tax.title') }}</th>
                      <th width="8%">{{ $t('tax.tax_withholding') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in formData.items" :key="index">
                      <td class="py-2 text-center vertical-top">{{ index + 1 }}</td>
                      <td class="py-2">
                        <v-text-field v-model="item.name" :placeholder="$t('product.product_name')" outlined dense hide-details
                          disabled></v-text-field>
                        <v-text-field v-model="item.detail" :placeholder="$t('detail')" outlined dense hide-details
                          value="detail"></v-text-field>
                      </td>
                      <!-- vuetify area select -->
                      <td class="py-2 vertical-top">
                        <v-select v-if="item.area" :disabled="true" v-model="item.area" :items="[item.area]" outlined
                          dense hide-details :no-data-text="$t('noinfo')">
                          <template v-slot:selection="{ item }">
                            <div class="d-block w-100" style="width: 100%">
                              <v-btn text v-if="item.isRemove">-</v-btn>
                              <template v-else>
                                <div class="d-block w-100">{{ item.name }}</div>
                                <div class="d-block w-100 text-right text-gray" style="font-size: 13px">{{ `${item.size ||
                                  '-'}${$t('square_meter')}` }}</div>
                              </template>
                            </div>
                          </template>
                        </v-select>
                        <v-text-field v-else :placeholder="$t('area.space')" class="input-center" outlined dense hide-details
                          value="-"></v-text-field>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          :placeholder="$t('product.quantity')" 
                          class="input-right input-disable-appearance" 
                          outlined dense
                          hide-details 
                          v-model="item.quantity" 
                          @input="(value) => (item.quantity = parseFloat(item.quantity))"
                          :rules="[rules.required]" 
                        />
                      </td>
                      <td class="py-2 vertical-top">
                        <v-text-field v-model="item.unit" :placeholder="$t('unit')" outlined dense hide-details :value="$t('product.box')"
                          :rules="[rules.required]"></v-text-field>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field
                          v-model="item.originalPricePerUnit"
                          :placeholder="$t('product.unit_price')"
                          class="input-right input-disable-appearance" 
                          outlined dense 
                          hide-details 
                          @input="(value) => (item.originalPricePerUnit = parseFloat(item.originalPricePerUnit))"
                          :rules="[rules.required]" 
                          :options="{ precision: {}}"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          v-model="item.discountPerUnit"
                          :placeholder="$t('product.unit_price')"
                          class="input-right input-disable-appearance" outlined dense hide-details 
                          @input="(value) => (item.discountPerUnit = parseFloat(item.discountPerUnit))"
                          :rules="item.type == 'discount' ? [] : [rules.required]"
                          :disabled="item.type == 'discount'" :suffix="item.discountType == 2 ? '%' : ''"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.sellVatType" :items="[
                          {
                            text: `${formData.vatPercent}%`,
                            value: 1,
                          },
                          {
                            text: '0%',
                            value: 2,
                          },
                          {
                            text: $t('except'),
                            value: 3,
                          },
                        ]" item-text="text" item-value="value" :placeholder="$t('product.unit_price')" outlined dense
                          hide-details :no-data-text="$t('noinfo')"></v-select>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.whtPercent" :items="taxWithheldOptions" item-text="name"
                          item-value="value" :placeholder="$t('product.withholding')" outlined lang hide-details :no-data-text="$t('noinfo')">
                          <template v-slot:selection="data">
                            <div class="d-block w-100" style="width: 100%;">
                              <template v-if="data.item.value > 0">
                                <div class="d-block w-100">
                                  {{ item.totalWhtValue | currency }}
                                  <br />
                                </div>
                              </template>
                              <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''"
                                :class="data.item.value > 0 ? 'text-right text-gray' : ''">{{ data.item.name }}</div>
                            </div>
                          </template>
                        </v-select>
                      </td>
                      <td class="py-4 text-right vertical-top">
                        <b>{{ item.totalOriginalValue | currency }}</b>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <v-row class="px-5 mt-3 mb-0">
              <v-col cols="4">
                <span>
                  <b>{{ $t('note') }}:</b>
                </span>
                <v-textarea v-model="formData.paymentNote" :placeholder="$t('note')" outlined dense hide-details rows="2"
                  no-resize></v-textarea>

                <div class="card--payment">
                  <div class="payment--header">
                    {{ $t('payment.title') }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="payment--body">
                    <div class="d-flex justify-space-between mb-2">
                      <div>{{ $t('payment.payment_money_method') }}</div>
                      <div><b>{{ formData.paymentMethodText }}</b></div>
                    </div>
                    <div class="d-flex justify-space-between mb-2">
                      <div>{{ $t('payment.payment_currency_code') }}</div>
                      <div class="d-flex align-center">
                        <img :src="`/images/currency/${formData.paymentCurrencyCode}.svg`" :alt="formData.paymentCurrencyCode" class="me-2 icon-currency"/>
                        <div>{{ $helper.currencyOptionName(formData.paymentCurrencyCode) }}</div>
                      </div>
                    </div>

                    <template v-if="formData.currencyCode != formData.paymentCurrencyCode">
                      <div class="d-flex justify-space-between">
                        <div>{{ $t('payment.real_received_amount') }}</div>
                        <div><span class="primary--text font-weight-bold">{{ formData.totalPaymentValue | currencySuffixTextThEn(formData.paymentCurrencyCode) }}</span></div>
                      </div>
                      <div class="d-flex justify-space-between">
                        <div></div>
                        <div>1 {{ $helper.currencyThEn(formData.paymentCurrencyCode) }} = {{ formData.exchangeRate }} {{ $helper.currencyThEn(formData.currencyCode) }}</div>
                      </div>
                      <div class="d-flex justify-space-between mt-3">
                        <div>{{ $t('payment.profit_or_loss') }}<br/>{{ $t('payment.from_exchange_rate') }}</div>
                        <div :class="formData.totalFxAainLossValue > 0 ? 'success--text' : formData.totalFxAainLossValue < 0 ? 'error--text' : ''">
                          {{ formData.totalFxAainLossValue | currencySuffixTextThEn(formData.currencyCode, { isShowPlus: true }) }}
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="d-flex justify-space-between">
                        <div>{{ $t('payment.real_received_amount') }}</div>
                        <div><span class="primary--text font-weight-bold">{{ formData.totalValue | currencySuffixTextThEn(formData.paymentCurrencyCode) }}</span></div>
                      </div>
                    </template>
                  </div>
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" class="pe-5">
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalOriginalValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalDiscountValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalNonVatItemsValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatItemsValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_vat') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number bold">{{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <div v-if="isWht">
                  <hr class="my-4" />
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number">{{ formData.totalWhtValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number bold">{{ (formData.totalValue - formData.totalWhtValue) | currencySuffixTextThEn(formData.currencyCode) }}</p>
                    </v-col>
                  </v-row>
                </div>
                <hr class="mt-4" />
                <hr class="mt-1" />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
      <v-card class="justify-center py-10 d-flex" v-if="isLoading">
        <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
      </v-card>
    </v-form>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <PrintDialog elementId="print-receipt-form" type="receipt" v-if="formData && formData.objectId"
      v-model="isPrintDialog" :receiptIds="[formData.objectId]" :lang="printLang" />
    <BillHederDialog v-if="receipt" v-model="isBillHederDialog" :receiptId="receipt.objectId"
      :customerData="formData.customerData" @onSaveSuccess="onSaveSuccess" :customerType="customerType" />
    <InvoiceDialog v-model="isInvoiceDialog" :invoiceId="invoiceId" :projectId="projectId"
      @onSaveSuccess="onSaveSuccess" />
    <MeterDigitalOrderDetailDialog
      v-if="formData.order"
      v-model="dialogMeterOrderDetail" 
      :orderId="formData.order.objectId" 
      :projectId="projectId"
    />
  </v-card>
</template>

<script>
import { DocumentItem, Invoice, Receipt } from "../classes";
import { mapState } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog.component";
import BankData from "../json/bank-data.json";
import PrintDialog from "@/components/PrintDialog.component.vue";
import BillHederDialog from "@/components/BillHederDialog.vue";
import EditTaxId from "@/components/EditTaxId.vue";
import CurrencySelect from "@/components/CurrencySelect.vue";
export default {
  props: {
    receiptId: String,
    projectId: String
  },
  components: {
    ConfirmDialog,
    PrintDialog,
    EditTaxId,
    BillHederDialog,
    InvoiceDialog: () => import('@/components/InvoiceDialog.component'),
    MeterDigitalOrderDetailDialog: () => import('@/components/MeterDigitalOrderDetailDialog'),
    CurrencySelect
  },
  data() {
    return {
      customerType: '',
      formData: {},
      rules: {
        required: value => !!value || this.$t('validate.please_input_data')
      },
      formData: {
        customerData: {},
        items: [],
        date: this.$moment().format("YYYY-MM-DD"),
        dueDate: this.$moment()
          .add(7, "days")
          .format("YYYY-MM-DD"),
        currencyCode: "THB",
        totalValue: 0,
        totalVatValue: 0,
        totalNonVatValue: 0,
        totalVatItemsValue: 0,
        totalNonVatItemsValue: 0,
        paymentCurrencyCode: "THB",
        totalPaymentValue: 0,
        exchangeRate: 0,
        totalExchangedValue: 0,
        totalFxAainLossValue: 0,
        isVatInclusive: 0,
        note: ""
      },
      isLoading: false,
      menuDate: false,
      menuDueDate: false,
      isSaving: false,
      isError: false,
      isSuccess: false,
      isDialogAccountingProduct: false,
      isConfirmDialog: false,
      isPaymentFormDialog: false,
      isUnsendConfirmDialog: false,
      isUnpaidConfirmDialog: false,
      receipts: [],
      BankData: BankData,
      isSendConfirmDialog: false,
      tempInvoice: null,
      tempReceipt: null,
      isPrintDialog: false, 
      printLang: 'th',
      isBillHederDialog: false,
      isInvoiceDialog: false,
      invoiceId: null,
      taxWithheldOptions: [
        {
          name: this.$t('not_specified_yet'),
          value: -1
        },
        {
          name: this.$t('no'),
          value: 0
        },
        {
          name: "0.75%",
          value: 0.75
        },
        {
          name: "1%",
          value: 1
        },
        {
          name: "1.5%",
          value: 1.5
        },
        {
          name: "2%",
          value: 2
        },
        {
          name: "3%",
          value: 3
        },
        {
          name: "5%",
          value: 5
        },
        {
          name: "10%",
          value: 10
        },
        {
          name: "15%",
          value: 15
        }
      ],
      dialogMeterOrderDetail: false,
    };
  },
  computed: {
    contractAreas() {
      return this.$store.getters["contract/getAreas"];
    },
    ...mapState({
      receipt: state => state.receipt.receipt,
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    accountingProductOptions() {
      return (
        this.accountingProducts?.map(d => {
          return {
            text: `${d.name}`,
            value: `${d.name}`,
            obj: d
          };
        }) || []
      );
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    userFullName() {
      return `${this.receipt?.createdBy?.firstName} ${this.receipt?.createdBy?.lastName}`;
    },
    isWht() {
      return this.formData.items.filter(d => d.whtPercent > 0).length > 0;
    }
  },
  async created() {
    this.isLoading = true;
    try {
      await this.initData();
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
      let productIdList = [
        ...new Set([
          ...this.receipt.items
            .filter(
              d =>
                d.accountingProduct &&
                this.accountingProducts.findIndex(
                  i => i.objectId === d.accountingProduct.objectId
                ) == -1
            )
            .map(x => x.accountingProduct.objectId)
        ])
      ];
      await this.$store.dispatch(
        "accountingProducts/getAccountingProductsByIds",
        productIdList
      );
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.isError = true;
    }
  },
  methods: {
    async initData() {
      try {
        if (this.receiptId) {
          await this.$store.dispatch("receipt/getById", this.receiptId);
          this.formData = this.receipt;
          if (this.receipt && this.receipt.contract && this.receipt.contract.customer)
            this.customerType = this.receipt.contract.customer.type;
        } else {
          this.formData = new Receipt({});
        }

        this.formData.sentBy = {
          className: "_User",
          objectId: this.user.objectId,
          __type: "Pointer"
        };

      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    onChangeIsVatInclusive() {
      for (let item of this.formData.items) {
        item.setMainIsVatInclusive = this.formData.isVatInclusive;
      }
    },
    chooseItem(product, index) {
      this.formData.items[index].quantity = 1;
      this.formData.items[index].name = product.name;
      this.formData.items[index].unit = product.unit;
      this.formData.items[index].sellVatType = product.sellVatType;
      if (product.objectId) {
        this.formData.items[index].accountingProduct = {
          className: "AccountingProduct",
          objectId: product.objectId,
          __type: "Pointer"
        };
      }
    },
    dismiss() {
      this.$emit("onDismiss", true);
    },
    onCancelConfirmDialog() {
      this.$emit("onDismiss", true);
    },
    async onSaveSuccess() {
      this.isLoading = true;
      try {
        await this.initData();
        this.$emit("onSaveSuccess", this.receipt);
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    clickInvoice(invoice) {
      this.invoiceId = invoice.objectId
      this.isInvoiceDialog = true
    },
    printClick(lang) {
      this.printLang = lang
      this.isPrintDialog = true
    },
    currencyCodeText(code) {
      if (code == 'THB') {
        return `${this.$t('country.THA')} - ${this.$t('baht')}`
      } else if (code == 'LAK') {
        return `${this.$t('country.LAO')} - LAK`
      } else if (code == 'USD') {
        return `${this.$t('country.USA')} - USD`
      } else {
        return `${this.$t('country.THA')} - ${this.$t('baht')}`
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}

.tool-bar {
  position: fixed;
  height: 70px;
  background-color: rgb(0, 166, 80);
  color: white;
}

.table-item.header {
  background-color: rgb(0, 166, 80);

  th {
    color: white !important;
    font-size: 15px;
  }
}

.summary-topic {
  margin: 5px 0;
  color: rgb(0, 166, 80);
}

.summary-number {
  margin: 5px 0;
  font-weight: bold;
}

.rounded-t {
  border-radius: 15px 15px 0 0 !important;
}

.rounded-b {
  border-radius: 0 0 15px 15px !important;
}

.rounded-none {
  border-radius: 0 !important;
}

.vertical-top {
  vertical-align: top !important;
}

.card-receipt-form {
  height: calc(100vh - 135px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.card--payment{
  border: 2px solid #47BD82;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
  box-shadow: 0px 12px 44px 0px rgba(0, 0, 0, 0.12);
  background-color: #fff;
  .payment--header{
    font-size: 18px;
    font-weight: bold;
    color: #47BD82;
  }
}
.icon-currency{
  border-radius: 50%;
  margin-top: 3px;
  width: 20px;
  height: 20px;
}

.icon-currency-avatar{
  height: 20px !important;
  min-width: 20px !important;
  width: 20px !important;
  margin-right: 5px !important;
}
</style>